// Split from newsletter.functions.ts so public consumers (home page LatestIssue,
// /bulten/$slug page) don't pull sanitize-html, zod schemas, or admin-only code
// into the client bundle. Each fn here uses minimal imports.

import { createServerFn } from "@tanstack/react-start";
import { supabaseAdmin } from "@/integrations/supabase/client.server";

export const getLatestNewsletterIssue = createServerFn({ method: "GET" })
  .handler(async () => {
    const { data } = await supabaseAdmin
      .from("newsletter_issues")
      .select("slug, subject, sent_at")
      .order("sent_at", { ascending: false })
      .limit(1)
      .maybeSingle();
    return { issue: data ?? null };
  });

export const getNewsletterIssueBySlug = createServerFn({ method: "GET" })
  .inputValidator((d: unknown): { slug: string } => {
    const obj = (d ?? {}) as { slug?: unknown };
    const slug = typeof obj.slug === "string" ? obj.slug.slice(0, 200) : "";
    if (!slug) throw new Error("slug required");
    return { slug };
  })
  .handler(async ({ data }) => {
    const { data: issue } = await supabaseAdmin
      .from("newsletter_issues")
      .select("slug, subject, html, sent_at")
      .eq("slug", data.slug)
      .maybeSingle();
    return { issue: issue ?? null };
  });

/** Public archive listing: every sent issue, newest first. */
export const listNewsletterIssues = createServerFn({ method: "GET" })
  .handler(async () => {
    const { data } = await supabaseAdmin
      .from("newsletter_issues")
      .select("slug, subject, sent_at")
      .order("sent_at", { ascending: false })
      .limit(500);
    return { issues: data ?? [] };
  });
